<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:27
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-30 23:35:28
-->
<template>
  <div class="accountantMy">
    <van-nav-bar class="mineHeader" :border="false">
      <span class="text" slot="title">我的</span>
    </van-nav-bar>
    <div class="userInfo">
      <div class="left">
        <!-- <img :src="roleTrans[currentRole]" alt="" /> -->
        <img v-if="currentRole == 1" :src="dispatch" alt="" />
        <img v-if="currentRole == 2" :src="accountant" alt="" />
        <img v-if="currentRole == 3" :src="workOrder" alt="" />
        <img v-if="currentRole == 4" :src="verifyPerson" alt="" />
        <img v-if="currentRole == 5" :src="workOrder" alt="" />
        <img v-if="currentRole == 6" :src="workOrder" alt="" />
      </div>
      <div class="right">
        <p class="name">{{ userInfo.name || "--" }}</p>
        <p class="phone">{{ userInfo.phone || "--" }}</p>
      </div>
      <div class="kucun" v-if="currentRole == 3" @click="stocks"></div>
      <div class="jues">
        {{
          currentRole == 1
            ? "调度"
            : currentRole == 2
              ? "会计"
              : currentRole == 3
                ? "安装"
                : currentRole == 4
                  ? "审核"
                  : currentRole == 5
                    ? "安装管理"
                    : currentRole == 6
                      ? "欣港工单管理"
                      : ""
        }}
      </div>
    </div>
    <div class="workInfo">
      <div class="item" v-for="item in info" :key="item.key">
        <p class="value">{{ item.value || "--" }}</p>
        <p class="label">{{ item.label }}</p>
      </div>
    </div>
    <!-- <div class="logOut">
      退出登录
    </div> -->
    <van-button plain class="logOut" @click="logOut">退出登录</van-button>
    <Footer :page="minePage"></Footer>
  </div>
</template>

<script>
import {
  palletPersonInfo,
  dispatchPersonInfo,
  workOrderPersonInfo,
  verifyPersonInfo,
  loginOut,
} from "@/utils/network/interface";
import dispatch from "@/assets/my/dispatch.png";
import accountant from "@/assets/my/accountant.png";
import workOrder from "@/assets/my/workOrder.png";
import verifyPerson from "@/assets/my/verifyPerson.png";
import Footer from "@/components/Footer";
export default {
  name: "",
  components: {
    Footer,
  },
  props: {},
  data() {
    return {
      dispatch, // 调度
      accountant, // 会计
      workOrder, // 安装
      verifyPerson,
      roleTrans: {
        1: "dispatch", // 调度
        2: "accountant", // 会计
        3: "workOrder", // 安装
        4: "verifyPerson", // 审核
        5: "workOrder", // 安装管理
        6: "workOrder", // 欣港工单管理
      },
      roleUrl: {
        1: dispatchPersonInfo, // 调度
        2: palletPersonInfo, // 会计
        3: workOrderPersonInfo, // 安装
        4: verifyPersonInfo, // 审核
        5: workOrderPersonInfo, // 安装管理
        6: workOrderPersonInfo, // 欣港工单管理
      },
      dispatchInfo: [
        {
          label: "未发布计划",
          value: "",
          key: "unpublishedPlan",
        },
        {
          label: "新增计划",
          value: "",
          key: "newlyPlan",
        },
        {
          label: "已发布计划",
          value: "",
          key: "publishedPlan",
        },
        // {
        //   label: "接单中",
        //   value: "",
        //   key: "receivingOrders",
        // },
        // {
        //   label: "已接单",
        //   value: "",
        //   key: "alreadyReceivingOrders",
        // },
        // {
        //   label: "已派单",
        //   value: "",
        //   key: "assigned",
        // },
      ],
      accountantInfo: [
        {
          label: "未中标",
          value: "",
          key: "outBid",
        },
        {
          label: "已中标",
          value: "",
          key: "bided",
        },
      ],
      workOrderInfo: [
        {
          label: "已完成工单数",
          value: "",
          key: "completeNum",
        },
        {
          label: "已提交船舶安装数",
          value: "",
          key: "submitInstallNum",
        },
        {
          label: "未完成工单数",
          value: "",
          key: "unfinishedNum",
        },
        {
          label: "未提交船舶安装数",
          value: "",
          key: "notSubmitInstallNum",
        },
      ],
      verifyPersonInfo: [
        {
          label: "审核驳回船舶",
          value: "",
          key: "rejectNum",
        },
        {
          label: "未审核船舶",
          value: "",
          key: "notCheckNum",
        },
        {
          label: "审核通过船舶",
          value: "",
          key: "passNum",
        },
      ],
      info: [],
      // currentRole: localStorage.getItem("role"),
    };
  },
  computed: {
    userInfo() {
      let userInfo = localStorage.getItem("userInfo");
      return userInfo ? JSON.parse(userInfo) : {};
    },
    currentRole() {
      let role = localStorage.getItem("role");
      return role || 1;
    },
    minePage() {
      // let index = [2, 2, 2, 2, 3];
      // 我的页面的索引值！！！！！特别注意，要是其他tabbar选中失效去对应模块的footer去改index
      let index = [2, 2, 1, 1, 2, 1];
      console.log(index[localStorage.getItem("role") - 1], "minpage");
      return index[localStorage.getItem("role") - 1];
    },
  },
  filters: {
    filterLabel(val) {
      let str = "";
      switch (val) {
        case "bided":
          str = "已中标";
          break;
        case "outBid":
          str = "未中标";
          break;
      }
    },
  },
  watch: {},
  created() { },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      if (this.currentRole == 6) return
      let url = this.roleTrans[this.currentRole];
      let request = this.roleUrl[this.currentRole];
      console.log(this.roleUrl, "dddws");
      request().then((res) => {
        // this.userInfo = res.data
        if (res.code === 200) {
          let data = res.data;
          for (let key in data) {
            this[`${url}Info`].map((c) => {
              if (c.key == key) {
                c.value = data[key];
              }
            });
          }
          this.info = this[`${url}Info`];
        } else {
          this.info = this[`${url}Info`];
        }
      });
    },
    stocks() {
      this.$router.push({
        path: "/stockc",
      });
    },
    logOut() {
      loginOut().then((res) => {
        if (res.code == 200) {
          this.$store.commit("updateToken", null);
          this.$store.commit("updateUserInfo", null);
          this.$store.commit("updateRole", null);
          localStorage.clear();
          this.$router.push("/login");
          setTimeout(() => {
            location.reload();
          }, 200);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@itemWidth: calc((100% - 10px) / 2);

.accountantMy {
  background: url("../../assets/icon/mineTop.png") top center no-repeat;
  background-size: 100% 100%;
  height: 214px;

  .mineHeader {
    background-color: transparent;
    font-size: 16px;
    color: #fff;

    .text {
      font-size: 16px;
      color: #fff;
    }
  }

  .workInfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 10px;
    margin-top: 16px;

    .item {
      flex: 0 0 @itemWidth;
      background-color: #fff;
      text-align: center;
      margin-bottom: 10px;
      height: 80px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 10px 0px rgba(63, 171, 249, 0.31);
      padding-top: 18px;

      .value {
        font-size: 25px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #44b1f9;
        line-height: 1;
        letter-spacing: -1px;
        margin-bottom: 8px;
      }

      .label {
        font-size: 13px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: center;
        color: #999999;
        line-height: 19px;
        letter-spacing: -0.52px;
      }
    }
  }

  .userInfo {
    padding: 40px 20px 16px;
    display: flex;
    align-items: center;
    position: relative;

    .left {
      flex: 0 0 64px;
      margin-right: 20px;

      img {
        display: block;
        width: 100%;
      }
    }

    .right {
      color: #fff;

      .name {
        font-size: 15px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 26px;
        letter-spacing: 0.93px;
      }

      .phone {
        font-size: 12px;
        font-family: Adobe Heiti Std, Adobe Heiti Std-R;
        font-weight: normal;
        text-align: left;
        color: #ffffff;
        line-height: 26px;
        letter-spacing: 0.74px;
      }
    }

    .kucun {
      position: absolute;
      top: 50px;
      right: 30px;
      width: 88px;
      height: 32px;
      background: url(../../assets/my/kucun.png) no-repeat;
      background-size: 100% 100%;
    }

    .jues {
      position: absolute;
      bottom: -10px;
      left: 28px;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 6px;
      padding: 2px 6px;
    }
  }

  .logOut {
    position: fixed;
    width: 270px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #44b1f9;
    border-radius: 36px;
    text-align: center;
    font-size: 13px;
    line-height: 36px;
    font-family: Source Han Sans CN, Source Han Sans CN-Medium;
    font-weight: 500;
    color: #44b1f9;
    bottom: 90px;
    left: 50%;
    margin-left: -135px;
  }
}
</style>
